import { Navigate } from "react-router-dom";

const ErrorPage = () => {
  return <Navigate to="/" replace />;
};

export default ErrorPage;
